<template>
  <b-container class="p-3" fluid>
    <b-row>
      <b-col>
        <div class="filter form-inline mb-3">
          <search-box v-model="search" />
        </div>
        <div v-if="!isCheckingListLoading">
          <checking-list-table
            @showEditModal="onShowEditModal"
            @showWaitingForClosureModal="onShowWaitingForClosureModal"
          />
          <waiting-for-closure-project-list-modal
            id="waitingForClosureProjectListModal"
            :project-id="previousProjectsLookupId"
            @close="onCloseWaitingForClosureModal"
          />
          <checking-detail-modal
            id="checkingDetailModal"
            :project-id="editingCheckingId"
            @close="onCloseEditModal"
          />
        </div>
        <div v-else class="text-center pt-4">
          <b-spinner class="mb-2" />
          <div>กำลังโหลดรายการโครงการ...</div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import CheckingListTable from '@/components/checking/CheckingListTable'
import CheckingDetailModal from '@/components/checking/DetailModal'
import WaitingForClosureProjectListModal from '@/components/checking/WaitingForClosureProjectListModal'
import SearchBox from '@/components/shared/SearchBox'

export default {
  components: {
    CheckingListTable,
    CheckingDetailModal,
    WaitingForClosureProjectListModal,
    SearchBox
  },
  data () {
    return {
      editingCheckingId: null,
      previousProjectsLookupId: null,
      searchTimeout: null
    }
  },
  computed: {
    isCheckingListLoading () {
      return this.$store.state.loadingStates.checking
    },
    search: {
      get () { return this.$store.state.checking.filters.search },
      set (value) {
        // Debounce input
        if (this.searchTimeout) {
          clearTimeout(this.searchTimeout)
        }

        this.searchTimeout = setTimeout(() => {
          this.$store.commit('checking/setSearchCheckingKeyword', value)
        }, 1000)
      }
    }
  },
  created () {
    this.$store.dispatch('checking/fetchAllCheckingList')
  },
  methods: {
    onShowEditModal (projectId) { this.editingCheckingId = projectId },
    onShowWaitingForClosureModal (projectId) { this.previousProjectsLookupId = projectId },
    onCloseEditModal () { setTimeout(() => { this.editingCheckingId = null }, 200) },
    onCloseWaitingForClosureModal () { setTimeout(() => { this.previousProjectsLookupId = null }, 200) }
  }
}
</script>
